const categoriesGroups = {
  phone_internet: {
    EN: 'Phone & internet ☎️',
    FR: 'Téléphone & internet ☎️',
    NL: 'Telephoon & internet ☎️',
    DE: 'Telefon & Internet ☎️',
  },
  restaurant_canteen: {
    EN: 'Bar, Canteen & Restaurant 🍝',
    FR: 'Bar, Cantine & Restaurant 🍝',
    NL: 'Bar, Kantine & Restaurant 🍝',
    DE: 'Bewirtung & Aufmerksamkeiten 🍝',
  },
  goods_for_resell: {
    EN: 'Goods for resale 🔀',
    FR: 'Biens destinés à la revente 🔀',
    NL: 'Handelsgoederen 🔀',
    DE: 'Waren zum Weiterverkauf 🔀',
  },
  investment_hardware: {
    EN: 'Hardware 🛠',
    FR: 'Matériel 🛠',
    NL: 'Materiaal 🛠',
    DE: 'Hardware 🛠',
  },
  machines: {
    EN: 'Machines 🏗',
    FR: 'Machines 🏗',
    NL: 'Machines 🏗',
    DE: 'Maschinen 🏗',
  },
  rent: {
    EN: 'Office & rent 💼',
    FR: 'Bureau & location 💼',
    NL: 'Kantoor & huur 💼',
    DE: 'Büro & Miete 💼',
  },
  shop_furniture: {
    EN: 'Office & shop furniture 🛋',
    FR: 'Mobilier de bureau et de magasin 🛋',
    NL: 'Kantoor- en Winkelmeubilair 🛋',
    DE: 'Büro- und Ladenmöbel 🛋',
  },
  technology: {
    EN: 'Technology  🖥',
    FR: 'Technologie  🖥',
    NL: 'Technologie  🖥',
    DE: 'Technik  🖥',
  },
  goods_materials_tools: {
    EN: 'Tools 🛠',
    FR: 'Outils 🛠',
    NL: 'Gereedschap 🛠',
    DE: 'Werkzeug 🛠',
  },
  tools: {
    EN: 'Tools 🛠',
    FR: 'Outils 🛠',
    NL: 'Gereedschap 🛠',
    DE: 'Werkzeug 🛠',
  },
  VAT: {
    EN: 'VAT 💰',
    FR: 'TVA  💰',
    NL: 'btw 💰',
    DE: 'Umsatzsteuer 💰',
  },
  workplace_maintenance: {
    EN: 'Workplace - maintenance 🧽',
    FR: 'Lieu de travail - entretien 🧽',
    NL: 'Onderhoud van werkplek 🧽',
    DE: 'Arbeitsplatz - Instandhaltung 🧽',
  },
  raw_material: {
    EN: 'Raw materials 🌾',
    FR: 'Matières premières 🌾',
    NL: 'Grondstoffen 🌾',
    DE: 'Rohmaterialien 🌾',
  },
};

export default categoriesGroups;
